;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('paymentType', PaymentType)

  function PaymentType () {
    var operation = function (type) {
      switch (type) {
        case 'wire_transfert':
          return 'Virement'
        case 'check':
          return 'Chèque'
        case 'cash':
          return 'Liquide'
        case 'invoice':
          return 'Report sur Facture'
        case 'credit_note':
          return 'Avoir'
        case 'stripe':
          return 'Stripe'
        case 'direct-debit':
          return 'Prélèvement'
        case 'not-documented':
          return 'Paiement non saisi'
        case 'credit-card':
          return 'Carte bancaire'
        case 'gift-card':
          return 'Bon cadeau'
        default:
          return '--'
      }
    }
    return operation
  }
})(window.angular)
